import { Col, Row } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import DocumentTable from "../components/generic_components/documentTable_components/DocumentTable";
import { DocumentStruct } from "../common/Interfaces";
import EnterReason from "../components/deleteDocument_components/EnterReason";

export default function DeleteDocument() {
  const location = useLocation();
  const deleteDocumentState = location.state?.deleteDocumentState;
  const selectedDocument: DocumentStruct = deleteDocumentState.document;
  const isAdvancedUser: boolean = deleteDocumentState.isAdvancedUser;
  return (
    <>
      <Row>
        <h5>Delete Document</h5>
      </Row>
      <Row className="padding-top">
        <DocumentTable
          exclude={false}
          noAction={true}
          documentResults={[selectedDocument]}
        />
      </Row>
      <Row className="padding-top">
        <Col xs={1}>
          <h5 className="padding-top">Reason</h5>
        </Col>
        <EnterReason
          document={selectedDocument}
          isAdvancedUser={isAdvancedUser}
        ></EnterReason>
      </Row>
    </>
  );
}
